module.exports = __webpack_public_path__ + "static/media/capas.3d3f153c.svg";